import { Moment } from "moment";

export function getMomentMidday(aMoment: Moment) {
    return aMoment.startOf('day').add(12, 'hours');
}

export function momentStartDay(aMoment: Moment) {
    return aMoment.startOf('day')
}

export function momentEndDay(aMoment: Moment) {
    return aMoment.endOf('day')
}